module.exports = __webpack_public_path__ + "static/media/karajan_dashboard_web_background.96e6c746.jpg";